import { get } from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getDoctorsFail, getDoctorsSuccess } from './actions';
import api from './api';
import { GET_DOCTORS_ACTIONS } from './constants';

interface Response {
  data?: any;
}

export function* getDoctors({ payload }: any) {
  try {
    const language: string = yield select(getLocaleSelector);
    const { longitude, latitude, page } = payload;

    const { data }: Response = yield call(api.getDoctors, {
      language,
      longitude,
      latitude,
      page,
    });
    yield put(getDoctorsSuccess(get(data, 'doctors', [])));
  } catch (error) {
    yield put(getDoctorsFail(error));
  }
}

export function* watchGetDoctors() {
  yield takeLatest(GET_DOCTORS_ACTIONS.START, getDoctors);
}

export default [watchGetDoctors];
